export enum AssignedFilterType {
  MyTickets = 'MY_TICKETS',
  AssignedToMe = 'ASSIGNED_TO_ME',
  Others = 'OTHERS',
}
